
import Hero from "@/components/Hero";
import IntroSection from "@/components/home/IntroSection";
import ServicesSection from "@/components/home/ServicesSection";
import CoursesSection from "@/components/home/CoursesSection";
import AboutSection from "@/components/home/AboutSection";
import ValuePropositionSection from "@/components/home/ValuePropositionSection";
import CTASection from "@/components/home/CTASection";

const Index = () => {
  return (
    <div className="fade-in">
      <Hero 
        title="Somaatiline enesejuhtimise coaching"
        subtitle="Olen Kaija Alliksaar, coach ja hüpnoterapeut, kellel on üle 15 aasta juhtimiskogemust. Toetan naisi nende teekonnal, aidates neil leida tasakaal ja ületada raskusi, kasutades kehateadlikku ja traumateadlikku lähenemist."
        bgColor="bg-gradient-to-r from-kaija-sage to-kaija-peach"
      />
      <IntroSection />
      <ServicesSection />
      <CoursesSection />
      <AboutSection />
      <ValuePropositionSection />
      <CTASection />
    </div>
  );
};

export default Index;
